"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _IframeUtility = _interopRequireDefault(require("./IframeUtility"));

var _EasingAnimation = _interopRequireDefault(require("../animation/EasingAnimation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Window scrolling utility
 */
var ScrollUtility = /*#__PURE__*/function () {
  function ScrollUtility() {
    _classCallCheck(this, ScrollUtility);
  }

  _createClass(ScrollUtility, null, [{
    key: "scrollToElement",

    /**
     * Scrolls the window to make the element visible.
     *
     * @param {object} options Options object.
     * @param {Element} options.element Element to scroll into view.
     * @param {string} options.platform Platform (nwp, irw, m2, mobile etc.).
     * @param {boolean} [options.animate] TRUE to animate. Default is TRUE.
     * @param {boolean} [options.center] TRUE to center the element. Default is TRUE.
     * @param {number} [options.minDistance] Minimal distance before scroll will be activated. Default is "200" (px).
     * @param {number} [options.scrollTopMargin] Scroll top margin that will be offset from the top of the element when the element height is greater than the screen height. Default is "10" (px);.
     */
    value: function scrollToElement(options) {
      if (_IframeUtility.default.isInsideIframe()) {
        this._scrollToElement(options);
      } else {
        _IframeUtility.default.scrollToElement(options);
      }
    }
    /**
     * Scrolls the window to make the element visible.
     *
     * @param {object} options Options object.
     * @param {Element} options.element Element to scroll into view.
     * @param {string} options.platform Platform (nwp, irw, m2, mobile etc.).
     * @param {boolean} [options.animate] TRUE to animate. Default is TRUE.
     * @param {boolean} [options.center] TRUE to center the element. Default is TRUE.
     * @param {number} [options.minDistance] Minimal distance before scroll will be activated. Default is "200" (px).
     * @param {number} [options.scrollTopMargin] Scroll top margin that will be offset from the top of the element when the element height is greater than the screen height. Default is "10" (px);.
     */

  }, {
    key: "_scrollToElement",
    value: function _scrollToElement(options) {
      var element = options.element,
          scrollTopMargin = options.scrollTopMargin,
          _options$center = options.center,
          center = _options$center === void 0 ? true : _options$center,
          _options$minDistance = options.minDistance,
          minDistance = _options$minDistance === void 0 ? 200 : _options$minDistance,
          _options$animate = options.animate,
          animate = _options$animate === void 0 ? true : _options$animate;
      var screenHeight = window.parent.innerHeight;
      var bodyRect = document.body.getBoundingClientRect();
      var elemRect = element.getBoundingClientRect();
      var elementTopY = elemRect.top - bodyRect.top;
      var elementCenterY = elemRect.height > screenHeight ? elementTopY : elementTopY - screenHeight / 2 + elemRect.height / 2;
      var endPositionY = center ? elementCenterY - scrollTopMargin : elementTopY - scrollTopMargin;
      var startY = window.pageYOffset !== undefined ? window.pageYOffset : window.document.documentElement.scrollTop;
      var currentX = window.pageXOffset !== undefined ? window.pageXOffset : 0;
      var distanceY = Math.abs(startY - endPositionY);

      if (distanceY > minDistance) {
        if (animate) {
          var animation = new _EasingAnimation.default();
          animation.on('frame', function (y) {
            return window.parent.scrollTo(0, y);
          });
          animation.startValue = startY;
          animation.endValue = endPositionY;
          var frames = Math.floor(distanceY / 10);
          animation.frames = frames;
          animation.start();
        } else {
          window.scrollTo(currentX, endPositionY);
        }
      }
    }
  }]);

  return ScrollUtility;
}();

exports.default = ScrollUtility;